"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSubheadingProperty = exports.subheadingPropertyDefinition = void 0;
exports.subheadingPropertyDefinition = {
    view: { label: 'Subheading' },
    constraints: [],
    type: 'text',
    multiple: false,
    name: 'subheading',
};
const isSubheadingProperty = (prop) => {
    return prop.name === exports.subheadingPropertyDefinition.name;
};
exports.isSubheadingProperty = isSubheadingProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3ViaGVhZGluZy5wcm9wZXJ0eS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9wcm9wZXJ0aWVzL3N1YmhlYWRpbmcucHJvcGVydHkudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBRWEsUUFBQSw0QkFBNEIsR0FBRztJQUMxQyxJQUFJLEVBQUUsRUFBRSxLQUFLLEVBQUUsWUFBWSxFQUFFO0lBQzdCLFdBQVcsRUFBRSxFQUFFO0lBQ2YsSUFBSSxFQUFFLE1BQU07SUFDWixRQUFRLEVBQUUsS0FBSztJQUNmLElBQUksRUFBRSxZQUFZO0NBQ2EsQ0FBQTtBQUkxQixNQUFNLG9CQUFvQixHQUFHLENBQUMsSUFBa0IsRUFBOEIsRUFBRTtJQUNyRixPQUFPLElBQUksQ0FBQyxJQUFJLEtBQUssb0NBQTRCLENBQUMsSUFBSSxDQUFBO0FBQ3hELENBQUMsQ0FBQTtBQUZZLFFBQUEsb0JBQW9CLHdCQUVoQyJ9